import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { LANGUAGES } from '../constants/languages';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const currentLang = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0];

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (code: string) => {
    i18n.changeLanguage(code);
    localStorage.setItem('language', code);
    handleClose();
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          borderRadius: '12px',
          px: 1.5,
          py: 0.5,
          gap: 0.5,
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: 'rgba(46, 134, 171, 0.08)'
          }
        }}
      >
        <Typography sx={{ fontSize: '1.3rem', lineHeight: 1 }}>
          {currentLang.flag}
        </Typography>
        <Typography sx={{
          fontSize: '0.8rem',
          fontWeight: 500,
          color: 'rgba(15, 23, 42, 0.7)',
          fontFamily: '"Inter", sans-serif'
        }}>
          {currentLang.code.toUpperCase()}
        </Typography>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            mt: 1,
            minWidth: 160,
            boxShadow: '0 8px 24px rgba(15, 23, 42, 0.12)'
          }
        }}
      >
        {LANGUAGES.map(lang => (
          <MenuItem
            key={lang.code}
            onClick={() => handleSelect(lang.code)}
            selected={lang.code === i18n.language}
            sx={{
              gap: 1.5,
              py: 1,
              borderRadius: '8px',
              mx: 0.5,
              '&.Mui-selected': {
                backgroundColor: 'rgba(46, 134, 171, 0.1)',
                '&:hover': {
                  backgroundColor: 'rgba(46, 134, 171, 0.15)'
                }
              }
            }}
          >
            <Typography sx={{ fontSize: '1.2rem', lineHeight: 1 }}>
              {lang.flag}
            </Typography>
            <Box>
              <Typography sx={{ fontSize: '0.9rem', fontWeight: 500 }}>
                {lang.label}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;
